import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { styles } from "../reportingHelpers";
import { getPrimaryOfficials } from "../officialRoles";

export const FixtureReportsHeader = ({
  homeTeam,
  awayTeam,
  fixture,
  periodsScores,
  title,
  locale,
  intl,
  roles,
}) => {
  const officialRoles = getPrimaryOfficials();
  const availableOfficials = (roles ?? [])
    .filter((person) => officialRoles.includes(person.role))
    .reduce((soFar, person) => {
      if (soFar[person.role]) {
        soFar[person.role].push(person);
        return soFar;
      }

      return {
        ...soFar,
        [person.role]: [person],
      };
    }, {});

  return (
    <View style={{ ...styles.header, width: "65%", alignItems: "flex-end" }}>
      <View style={{ width: "3cm" }}></View>
      <View style={{ alignItems: "center" }}>
        <Text style={{ fontWeight: "bold", fontSize: 14 }}>
          {homeTeam.team.name + " - " + awayTeam.team.name}{" "}
          <View
            style={{
              width: "45mm",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                textAlign: "right",
                paddingRight: 3,
                fontSize: 10,
              }}
            >
              {homeTeam.name}
            </Text>
            <Text
              style={{
                fontWeight: "bold",
                fontSize: 14,
                textAlign: "left",
              }}
            >
              {homeTeam.score ? homeTeam.score : 0}
            </Text>
          </View>
          <View>
            <Text style={{ fontSize: 14, width: "3mm", textAlign: "center" }}>
              -
            </Text>
          </View>
          <View
            style={{
              width: "45mm",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Text
              style={{
                flex: 0,
                fontWeight: "bold",
                fontSize: 14,
                textAlign: "left",
              }}
            >
              {awayTeam.score ? awayTeam.score : 0}
            </Text>
            <Text
              style={{
                textAlign: "left",
                paddingLeft: 3,
                fontSize: 10,
              }}
            >
              {awayTeam.name}
            </Text>
          </View>
        </Text>
        <View>
          <Text style={{ fontSize: 10, fontWeight: "bold" }}>
            {"(" + periodsScores.join(", ") + ")"}
          </Text>
        </View>
        <Text style={{ fontSize: 10 }}>{fixture.venueName}</Text>
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            alignItems: "center",
            marginBottom: 20,
            marginTop: 5,
          }}
        >
          {Object.keys(availableOfficials).map((key) => (
            <>
              <Text
                style={{
                  fontFamily: ["Noto Sans", "Noto Sans TC"],
                  fontWeight: "bold",
                  fontSize: 7.7,
                }}
              >
                {intl.formatMessage({
                  id: `reports.role.${key.toLowerCase()}`,
                  defaultMessage: "Official role",
                })}
                :{" "}
              </Text>
              {availableOfficials[key].map((person, idx) => (
                <Text style={{ fontSize: 7.7 }}>
                  {person.name}
                  {idx + 1 === availableOfficials[key].length ? "; " : ", "}
                </Text>
              ))}
            </>
          ))}
        </View>
      </View>
    </View>
  );
};

export const parseScoringIntervals = (teamData, scoringIntervals, intl) => {
  const periods = [];
  const team = teamData.team || teamData;

  let periodLabel = intl.formatMessage({
    id: "reports.header.periodlabel",
    defaultMessage: "Q",
  });
  let overtimeLabel = intl.formatMessage({
    id: "reports.header.overtimelabel",
    defaultMessage: "OT",
  });

  let newPeriod = {
    interval1: 0,
    interval2: undefined,
    label: "",
    isOverTime: false,
  };
  let periodCount = 1;

  scoringIntervals.forEach((element, index) => {
    if (element.interval_number < 9) {
      if (element.interval_number % 2) {
        newPeriod.interval1 = element[team.entityId];
        newPeriod.interval2 = undefined;
        newPeriod.label = periodLabel + periodCount.toString();
        newPeriod.isOverTime = false;
        periodCount++;

        if (index === scoringIntervals.length - 1) {
          periods.push({ ...newPeriod });
        }
      } else {
        newPeriod.interval2 = element[team.entityId];
        periods.push({ ...newPeriod });
      }
    } else {
      if (element.interval_number === 9) {
        periodCount = 1;
      }
      newPeriod.interval1 = element[team.entityId];
      newPeriod.label = overtimeLabel + periodCount.toString();
      newPeriod.interval2 = undefined;
      newPeriod.isOverTime = true;
      periodCount++;
      periods.push({ ...newPeriod });
    }
  });

  return periods;
};
